/* eslint no-shadow: "off" */
export interface EmployeeItem {
  employeeId: number;
  employeeName: string;
}

export interface TansItem extends EmployeeItem {
  key: string;
  title: string;
}

export interface AddScheduleParams {
  scheduleName: string;
  scheduleBeginTime: string;
  scheduleEndTime: string;
  scheduleHourRange: Record<string, number>;
  employeeList: Array<number>;
  workWeekday: Array<number>;
  distributionUnitId: string | number;
  scheduleType: number;
  scheduleId?: number;
}

export interface DISTRICT_COLUMN_PROPS {
  distributionUnitName: string;
  distributionUnitId: number;
  scheduleEndTime: string;
}

export interface GET_STAFF_PARAM {
  type: SCHEDULE_TYPE_MAP.DELIVERY | SCHEDULE_TYPE_MAP.SERVICE;
  distributionUnitId: string;
  filterScheduled?: STAFF_FILTERED.NO | STAFF_FILTERED.YES;
  filterDate?: string;
}

export enum SCHEDULE_TYPE_MAP {
  DELIVERY = 0, // 配送排班
  SERVICE = 1, // 分餐排班
}

export enum WORK_STATUS {
  WORK = 1, // 上岗
  REST = 0, // 未上岗
}

export enum STAFF_FILTERED {
  /** 过滤已排班员工 */
  YES = 1,
  /** 不过滤已排班员工 */
  NO = 0,
}
